import AoneService from "../axiosbase";

export const getRoles = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/roles/" + params);
  } catch (error) {
    return error;
  }
};

export const postRoles = async (data) => {
  try {
    return await AoneService.post("user-management/api/v1/roles/", data);
  } catch (error) {
    return error;
  }
};

export const getRoleById = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/roles/" + params);
  } catch (error) {
    return error;
  }
};

export const updateRoleById = async (params, data) => {
  try {
    return await AoneService.put(
      `user-management/api/v1/roles/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const deleteRoleById = async (params) => {
  try {
    return await AoneService.delete("user-management/api/v1/roles/" + params);
  } catch (error) {
    return error;
  }
};

export const syncRoles = async () => {
  try {
    return await AoneService.get("user-management/api/v1/roles/sync");
  } catch (error) {
    return error;
  }
};

export const getUsersByRoleIdOrGroupId = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/users" + params);
  } catch (error) {
    return error;
  }
};

export const getUsersByGroupId = async (params) => {
  try {
    return await AoneService.get(
      "user-management/api/v1/users/groups/" + params
    );
  } catch (error) {
    return error;
  }
};

export const downloadUsersByRoleId = async (params) => {
  try {
    return await AoneService.get(
      `user-management/api/v1/users/role/download` + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getGroups = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/groups/" + params);
  } catch (error) {
    return error;
  }
};

export const getGroupsTree = async () => {
  try {
    return await AoneService.get("user-management/api/v1/groups/tree");
  } catch (error) {
    return error;
  }
};

export const syncGroups = async () => {
  try {
    return await AoneService.get("user-management/api/v1/groups/sync");
  } catch (error) {
    return error;
  }
};

export const postGroups = async (data) => {
  try {
    return await AoneService.post("user-management/api/v1/groups/", data);
  } catch (error) {
    return error;
  }
};

export const postChildGroups = async (params, data) => {
  try {
    return await AoneService.post(
      `user-management/api/v1/groups/${params}/subgroups`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const deleteGroupById = async (params) => {
  try {
    return await AoneService.delete("user-management/api/v1/groups/" + params);
  } catch (error) {
    return error;
  }
};

export const getGroupsByUserId = async (params) => {
  try {
    return await AoneService.get(
      `user-management/api/v1/users/${params}/groups`
    );
  } catch (error) {
    return error;
  }
};

export const getSubGroups = async (params) => {
  try {
    return await AoneService.get(
      `user-management/api/v1/groups/${params}/subgroups`
    );
  } catch (error) {
    return error;
  }
};

export const getUsers = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/users/" + params);
  } catch (error) {
    return error;
  }
};

export const postUsers = async (data) => {
  try {
    return await AoneService.post("user-management/api/v1/users/", data);
  } catch (error) {
    return error;
  }
};

export const resetUsersPassword = async (data) => {
  try {
    return await AoneService.post("user-management/api/v1/users/reset-password", data);
  } catch (error) {
    return error;
  }
};

export const putUsersById = async (params, data) => {
  try {
    return await AoneService.put(
      `user-management/api/v1/users/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const getUsersById = async (params) => {
  try {
    return await AoneService.get("user-management/api/v1/users/" + params);
  } catch (error) {
    return error;
  }
};

export const deleteUserById = async (params) => {
  try {
    return await AoneService.delete("user-management/api/v1/users/" + params);
  } catch (error) {
    return error;
  }
};

export const getAssignedRolesByUserId = async (params) => {
  try {
    return await AoneService.get(
      `user-management/api/v1/users/${params}/roles`
    );
  } catch (error) {
    return error;
  }
};

export const assignRolesToUserId = async (params1, params2) => {
  try {
    return await AoneService.post(
      `user-management/api/v1/users/${params1}/role/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const assignGroupsToUserId = async (params1, params2) => {
  try {
    return await AoneService.post(
      `user-management/api/v1/users/${params1}/group/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const unassignRolesOfUserId = async (params1, params2) => {
  try {
    return await AoneService.delete(
      `user-management/api/v1/users/${params1}/role/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const unassignGroupsOfUserId = async (params1, params2) => {
  try {
    return await AoneService.delete(
      `user-management/api/v1/users/${params1}/group/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const assignRolesToGroupId = async (params1, params2) => {
  try {
    return await AoneService.post(
      `user-management/api/v1/groups/${params1}/role/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const unassignRolesOfGroupId = async (params1, params2) => {
  try {
    return await AoneService.delete(
      `user-management/api/v1/groups/${params1}/role/${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const getAssignedRolesByGroupId = async (params) => {
  try {
    return await AoneService.get(
      `user-management/api/v1/groups/${params}/roles`
    );
  } catch (error) {
    return error;
  }
};

//get all modules
export const getAllModules = async () => {
  try {
    return await AoneService.get(`user-management/api/v1/module/all`);
  } catch (error) {
    return error;
  }
};

//get submodule
export const getSubModules = async (params) => {
  try {
    return await AoneService.get(`user-management/api/v1/subModule?${params}`);
  } catch (error) {
    return error;
  }
};

//get model
export const getModels = async (params) => {
  try {
    return await AoneService.get(`user-management/api/v1/model?${params}`);
  } catch (error) {
    return error;
  }
};

//get permissions
export const getPermissions = async (params) => {
  try {
    return await AoneService.get(`user-management/api/v1/permission?${params}`);
  } catch (error) {
    return error;
  }
};


//get all submodules
export const getAllSubModules = async () => {
  try {
    return await AoneService.get(`user-management/api/v1/subModule/all`);
  } catch (error) {
    return error;
  }
};

//get all models
export const getAllModels = async () => {
  try {
    return await AoneService.get(`user-management/api/v1/model/all`);
  } catch (error) {
    return error;
  }
};

//get all permissions
export const getAllPermissions = async () => {
  try {
    return await AoneService.get(`user-management/api/v1/permission/all`);
  } catch (error) {
    return error;
  }
};

//create / update / delete module
export const postModule = async (data) => {
  try {
    return await AoneService.post(`user-management/api/v1/module`, data);
  } catch (error) {
    return error;
  }
};

export const updateModuleById = async (id, data) => {
  try {
    return await AoneService.put(`user-management/api/v1/module/${id}`, data);
  } catch (error) {
    return error;
  }
};

export const deleteModuleById = async (id) => {
  try {
    return await AoneService.delete(`user-management/api/v1/module/${id}`);
  } catch (error) {
    return error;
  }
};

//create / update / delete submodule
export const postSubModule = async (data) => {
  try {
    return await AoneService.post(`user-management/api/v1/subModule`, data);
  } catch (error) {
    return error;
  }
};

export const updateSubModuleById = async (id, data) => {
  try {
    return await AoneService.put(`user-management/api/v1/subModule/${id}`, data);
  } catch (error) {
    return error;
  }
};

export const deleteSubModuleById = async (id) => {
  try {
    return await AoneService.delete(`user-management/api/v1/subModule/${id}`);
  } catch (error) {
    return error;
  }
};

//create / update / delete model
export const postModel = async (data) => {
  try {
    return await AoneService.post(`user-management/api/v1/model`, data);
  } catch (error) {
    return error;
  }
};

export const updateModelById = async (id, data) => {
  try {
    return await AoneService.put(`user-management/api/v1/model/${id}`, data);
  } catch (error) {
    return error;
  }
};

export const deleteModelById = async (id) => {
  try {
    return await AoneService.delete(`user-management/api/v1/model/${id}`);
  } catch (error) {
    return error;
  }
};

//create / update / delete permission
export const postPermission = async (data) => {
  try {
    return await AoneService.post(`user-management/api/v1/permission`, data);
  } catch (error) {
    return error;
  }
};

export const updatePermissionById = async (id, data) => {
  try {
    return await AoneService.put(`user-management/api/v1/permission/${id}`, data);
  } catch (error) {
    return error;
  }
};

export const deletePermissionById = async (id) => {
  try {
    return await AoneService.delete(`user-management/api/v1/permission/${id}`);
  } catch (error) {
    return error;
  }
};

//rename groups
export const renameGroups = async (params, data) => {
  try {
    return await AoneService.patch(
      `user-management/api/v1/groups/${params}/name`,
      data
    );
  } catch (error) {
    return error;
  }
};

//export users
export const exportUsers = async () => {
  try {
    return await AoneService.get("user-management/api/v1/users/export", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const createClient = async (data) => {
  try {
    return await AoneService.post(`user-management/api/v1/clients`, data);
  } catch (error) {
    return error;
  }
};

export const updateClient = async (clientId, data) => {
  try {
    return await AoneService.patch(`user-management/api/v1/clients/${clientId}`, data);
  } catch (error) {
    return error;
  }
};

export const getClientDetails = async (clientId) => {
  try {
    return await AoneService.get(`user-management/api/v1/clients/${clientId}`);
  } catch (error) {
    return error;
  }
};

export const enableClient = async (clientId) => {
  try {
    return await AoneService.put(`user-management/api/v1/clients/${clientId}/enable`);
  } catch (error) {
    return error;
  }
};

export const disableClient = async (clientId) => {
  try {
    return await AoneService.put(`user-management/api/v1/clients/${clientId}/disable`);
  } catch (error) {
    return error;
  }
};

export const regenerateClientSecret = async (clientId) => {
  try {
    return await AoneService.post(`user-management/api/v1/clients/${clientId}/regenerate-secret`);
  } catch (error) {
    return error;
  }
};

export const getClientSecret = async (clientId) => {
  try {
    return await AoneService.get(`user-management/api/v1/clients/${clientId}/secret`);
  } catch (error) {
    return error;
  }
};

export const savePermissions = async (clientId, data) => {
  try {
    return await AoneService.post(`user-management/api/v1/clients/${clientId}/roles/realm`, data);
  } catch (error) {
    return error;
  }
};
